import {useAtomValue} from 'jotai';
import {useEffect, useState} from 'react';
import {zoomLevelAtom} from '../atom';
import {MARKER_COUNT_LIMIT} from '../constants';

export const useAdjustMarkerCount = (
  originalLimit: number = MARKER_COUNT_LIMIT
) => {
  const zoomLevel = useAtomValue(zoomLevelAtom);
  const [adjustedPercent, setPercent] = useState<number>(1);

  useEffect(() => {
    if (originalLimit <= 30 || zoomLevel > 14) {
      setPercent(1);
    } else {
      let percentage: number;

      if (zoomLevel >= 13) {
        percentage = 0.6;
      } else if (zoomLevel >= 12) {
        percentage = 0.4;
      } else {
        percentage = 0.2;
      }

      setPercent(percentage * (originalLimit > 100 ? 0.7 : 1));
    }
  }, [zoomLevel, originalLimit]);

  return adjustedPercent;
};
